import { UserRole } from './types';

export const noragReadRoles: UserRole[] = [
  'SUPERADMIN',
  'ADMIN',
  'OPERATOR',
  'ADMIN_INTERNO',
  'JEFE_AREA',
  'USER',
  'ENCARGADO',
];

export const noragWriteRoles: UserRole[] = ['SUPERADMIN', 'ADMIN', 'JEFE_AREA', 'ENCARGADO'];

export const noragTemplateRoles: UserRole[] = ['SUPERADMIN', 'ADMIN', 'ENCARGADO'];

export const noragBookRoles: UserRole[] = ['SUPERADMIN', 'ADMIN', 'ENCARGADO'];

export const noragBotRoles: UserRole[] = ['SUPERADMIN', 'ADMIN'];

export function canReadNorag(role?: UserRole | null): boolean {
  return role != null && noragReadRoles.includes(role);
}

export function canWriteNorag(role?: UserRole | null): boolean {
  return role != null && noragWriteRoles.includes(role);
}

export function canUseTemplates(role?: UserRole | null): boolean {
  return role != null && noragTemplateRoles.includes(role);
}

export function canUseBooks(role?: UserRole | null): boolean {
  return role != null && noragBookRoles.includes(role);
}

export function canUseBots(role?: UserRole | null): boolean {
  return role != null && noragBotRoles.includes(role);
}
